export function makeI18nField(options = {}) {
  const {
    required = false,
    type = ["string", "null"], // rich text fields hold Tiptap objects instead
    ...constraints // all other props (minLength, maxLength, pattern, etc.)
  } = options;

  // Base properties
  const properties = {};

  const schema = {
    type: "object",
    properties,
    additionalProperties: false,
    patternProperties: {
      "^[a-z]{2}$": {
        type,
        ...constraints,
      },
    },
  };

  if (required) {
    schema.minProperties = 1;
    schema.i18nRequired = true;
  }
  return schema;
}
